// extracted by mini-css-extract-plugin
module.exports = {"logo":"footer_logo__SnCj9","link":"footer_link__Ed1mB","footer":"footer_footer__Jqiqm","logoFooter":"footer_logoFooter__x7BLb"};